import { render, staticRenderFns } from "./TheDevGuideSidebar.vue?vue&type=template&id=1d66e1bb&scoped=true&"
import script from "./TheDevGuideSidebar.vue?vue&type=script&lang=js&"
export * from "./TheDevGuideSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheDevGuideSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheDevGuideSidebar.vue?vue&type=style&index=1&id=1d66e1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66e1bb",
  null
  
)

export default component.exports